import { Input } from "@progress/kendo-react-inputs";

export const WidthProperty = {
  propertyName: "Width",
  propertyDisplay: "Width",
  propertyType: "number",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        type={"number"}
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || 120}
      />
    );
  },
};
